// mixins/theme.js
export default {
    computed: {
        themeColors() {
            return this.$store.state.template.globalStyle
        }
    },
    methods: {
        getThemeVar(name) {
            return getComputedStyle(document.documentElement)
                .getPropertyValue(`--theme-${name}`)
                .trim()
        },
        applyThemeStyle(el, styleMap) {
            const originalStyles = {}

            // 存储原始样式
            Object.keys(styleMap).forEach(prop => {
                originalStyles[prop] = el.style[prop]
            })

            // 应用新样式
            const apply = () => {
                Object.entries(styleMap).forEach(([prop, themeKey]) => {
                    el.style[prop] = this.themeColors[themeKey] || this.getThemeVar(themeKey)
                })
            }

            // 清除样式
            const clear = () => {
                Object.entries(originalStyles).forEach(([prop, value]) => {
                    el.style[prop] = value
                })
            }

            return { apply, clear }
        }
    }
}
